import { useState, useEffect } from 'react';
import { AISummaryService } from './AISummaryService';
import { ITranscriptEntry } from './AISummary.types';

export function useTranscript(containerId: string | undefined) {
  const [transcriptEntries, setTranscriptEntries] = useState<ITranscriptEntry[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!containerId) {
      setTranscriptEntries([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const service = AISummaryService.getInstance();
        const containerInfo = await service.getContainer(containerId);
        if (cancelled) return;
        const entries = await service.fetchTranscript(containerInfo);
        if (cancelled) return;
        setTranscriptEntries(entries);
      } catch (err) {
        if (cancelled) return;
        console.warn('[useTranscript] Failed to fetch transcript:', err);
        setTranscriptEntries([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [containerId]);

  return { transcriptEntries, loading };
}
